import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile, formatDateDb } from "../../utils/tools";
import { formatDateToLocal, formatPriceUS } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {
  InputControl,
  SelectControl,
} from "../../components/form/formControls";
import { useCategories } from "../../categorys/calculateServiceFees/detail";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { commissionCall } from "../../api/commission";
import { attendanceCall } from "../../api/attendance";
import Decimal from "decimal.js";

// ─── Decimal helpers ───────────────────────────────────────────────────────
const _D = (v) => {
  try {
    const d = new Decimal(v ?? 0);
    return d.isFinite() ? d : new Decimal(0);
  } catch {
    return new Decimal(0);
  }
};
const _safeDivD = (a, b, fallback = 0) => {
  const db = _D(b);
  return db.isZero() ? new Decimal(fallback) : _D(a).div(db);
};
// ──────────────────────────────────────────────────────────────────────────

const schemaEdit = Yup.object().shape({
  employeeId: Yup.string().required("Nhân viên tham gia là bắt buộc"),
  relativeId: Yup.string().optional(),
  commissionRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Ngày công là bắt buộc"),
  workingDays: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Ngày công là bắt buộc"),
  commissionPrice: Yup.string(),
});

export default memo(function Step3ManagerBlockAreaForm({
  lockingId,
  locking,
  item,
  index, // index của item trong items[]
  parentIndex, // index của manager trong saleAreaManagers[]
  onChangeRow,
  title,
  handleRemoveRow,
  setStepHandle,
  mainSellerCommissionRate,
}) {
  const {
    register,
    setValue,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaEdit),
    defaultValues:
      {
        ...item,
      } || {},
  });

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };
  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };
  const [commissionPrice, setCommissionPrice] = useState(0);

  const [shouldFetch, setShouldFetch] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(
    watch("employeeId") || item?.employeeId,
    shouldFetch,
  );

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const employeeDatas = useMemo(
    () => formatEntries(constantData?.relativeData),
    [constantData?.relativeData],
  );

  const getAttendance = async (employeeId, locking) => {
    const date = locking?.transactionDate
      ? new Date(locking.transactionDate)
      : new Date();
    const month = date.getMonth() + 1; // Lấy tháng từ 1 đến 12
    const year = date.getFullYear();

    const attendance = await attendanceCall.getByEmployee(
      employeeId,
      month,
      year,
    );

    const newWorkingDays = attendance?.workingDays || 0;
    const amountHeld = attendance?.brokerDebtCertificate?.amountHeld || 0;

    onChangeRow(parentIndex, index, {
      workingDays: Number(newWorkingDays),
      amountHeld: Number(amountHeld),
    });
  };
  const onchangeEmpoyeeList = (option) => {
    // setValue("employeeId", option);
    onChangeRow(parentIndex, index, { employeeId: option });
    if (option && locking) {
      getAttendance(option, locking);
    }
  };

  //   const relativeDatas = useMemo(
  //     () => formatEntries(constantData?.relativeData),
  //     [constantData?.relativeData]
  //   );

  //   const onchangeRelativeList = (option) => {
  //     setValue("relativeId", option);
  //   };

  const onChangeCommissionPrice = useCallback((event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setCommissionPrice(formatPriceUS(numericValue));
    //   setValue("commissionPrice", Number(numericValue), {
    //     shouldValidate: true,
    //   });
    onChangeRow(parentIndex, index, { commissionPrice: Number(numericValue) });
  }, []);

  useEffect(() => {
    if (!item) return;

    const {
      kRate = 0,
      calculateCommissionRate = 0,
      transactionRate = 100,
      commissionRate = 0,
      workingDays = 0,
      standardWorkingDaysInMonth = 0,
      priceForCommission = 0,

      //
      displayReferralPrice = 0,
      commissionRateBlockManagerDH = 0,
      commissionRateBlockManagerDT = 0,
      commissionRateBlockManagerCL = 0,
      commissionRateAreaManagerDH = 0,
      commissionRateAreaManagerDT = 0,
      commissionRateAreaManagerCL = 0,
      commissionRateGeneralDirector = 0,
    } = item;

    const workingDayRate = workingDays / standardWorkingDaysInMonth;

    // commissionRate đã là tỉ lệ hiệu dụng (đã gồm phần người bán chính mainSellerRate)
    // nên KHÔNG nhân mainSellerRate lần nữa để tránh chia đôi số tiền.
    const commissionPrice = _D(kRate)
      .mul(_D(calculateCommissionRate).div(100))
      .mul(_D(commissionRate).div(100))
      .mul(_D(workingDayRate))
      // .mul(_D(transactionRate).div(100))
      .mul(_D(priceForCommission))
      .toNumber();
    // ────────────────────────────────────────────────────────────────────────

    setCommissionPrice(formatPriceUS(commissionPrice));
    onChangeRow(parentIndex, index, {
      commissionPrice: Number(commissionPrice),
    });
  }, [item?.commissionRate, item?.workingDays]);

  useEffect(() => {
    if (!item) return;

    const commissionPrice = Number(item?.commissionPrice || 0);

    setCommissionPrice((prev) => {
      const formatted = formatPriceUS(commissionPrice);
      return prev !== formatted ? formatted : prev;
    });

    onChangeRow(parentIndex, index, {
      commissionPrice,
    });
  }, [item?.commissionPrice]);

  return (
    <Box w={"100%"}>
      <Text
        color={"var(--color-header-employee)"}
        fontSize={"14px"}
        fontWeight={"600"}
      >
        {title ? title : item?.isCollaborator ? "Người bán chính" : "CTV"}
      </Text>
      {/* 3 */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        mb={"12px"}
        w={"100%"}
      ></Flex>
      {/* 4 */}

      {/* 5 */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        mb={"12px"}
        w={"100%"}
      >
        <Box flex={1}>
          <SelectControl
            label={"Nhân viên tham gia"}
            dataOption={employeeDatas}
            placeholder="Chọn nhân viên tham gia"
            selectedMain={watch("employeeId")}
            onChange={onchangeEmpoyeeList}
            onFocus={() => handleFocus("employeeId")}
            onBlur={() => handleBlur("employeeId")}
            state={focusStates["employeeId"]}
            registerProps={register("employeeId")}
            errorMessage={errors.employeeId}
            mwidth="100%"
            isSearchable={true}
            isRequired={true}
          />
        </Box>

        <Box flex={1}>
          <InputControl
            type="number"
            label="Tỉ lệ (%)"
            placeholder="Nhập tỉ lệ"
            errors={errors.commissionRate}
            register={register("commissionRate")}
            onFocus={() => handleFocus("commissionRate")}
            onBlur={() => handleBlur("commissionRate")}
            state={focusStates["commissionRate"]}
            mwidth={"100%"}
            onlyPositiveNumbers={true}
            value={item.commissionRate}
            onChange={(e) =>
              onChangeRow(parentIndex, index, {
                commissionRate: Number(e.target.value),
              })
            }
            onChangeData={() => setStepHandle(1)}
            // disabled={true}
          />
          <Text
            mt={"6px"}
            color={"var(--color-secondary)"}
            fontSize={"14px"}
            fontWeight={400}
            minW={"140px"}
          >
            (Cho phép chỉnh sửa)
          </Text>
        </Box>

        <Box flex={1}>
          <InputControl
            type="number"
            label="Ngày công "
            placeholder="Nhập Ngày công VD: 23.5"
            errors={errors.workingDays}
            register={register("workingDays")}
            onFocus={() => handleFocus("workingDays")}
            onBlur={() => handleBlur("workingDays")}
            state={focusStates["workingDays"]}
            mwidth={"100%"}
            onlyPositiveNumbers={true}
            value={item.workingDays}
            onChange={(e) => {
              onChangeRow(parentIndex, index, {
                workingDays: Number(e.target.value),
              });
            }}
            onChangeData={() => setStepHandle(1)}
          />
          <Text
            mt={"6px"}
            color={"var(--color-secondary)"}
            fontSize={"14px"}
            fontWeight={400}
            minW={"140px"}
          >
            (Cho phép chỉnh sửa)
          </Text>
        </Box>

        <Box flex={1}>
          <InputControl
            // type="number"
            label="Số tiền"
            placeholder="Số tiền"
            errors={errors.commissionPrice}
            register={register("commissionPrice")}
            onFocus={() => handleFocus("commissionPrice")}
            onBlur={() => handleBlur("commissionPrice")}
            onChange={onChangeCommissionPrice}
            value={commissionPrice}
            state={focusStates["commissionPrice"]}
            mwidth={"100%"}
            isLockInput={true}
            readOnly={true}
          />
        </Box>

        {/* <Button
          size="sm"
          colorScheme="red"
          variant="outline"
          onClick={() => handleRemoveRow(parentIndex, index)}
        >
          Xóa
        </Button> */}
      </Flex>
    </Box>
  );
});
